import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function customerAttachments(token: string): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('customerAttachments')
    .setMethod('POST')
    .setProps([{token: token}])
    .send();
}
  